/* eslint-disable max-len */
import React from 'react'
import { Text, View, Collider, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import Colors from '../../utils/colors'
import { Styles } from './styles'

const questions = [{
  question: '¿Cuál es el tiempo de respuesta promedio de mi crédito?',
  answer: '¡Podemos formalizar tu crédito en 6 semanas!',
  id: 'collider0'
},
{
  question: '¿En cuánto tiempo puedo tener el dinero?',
  answer: 'Tu dinero será depositado al día siguiente de la firma.',
  id: 'collider1'
},
{
  question: 'No tengo historial crediticio o mi buró de crédito no fue aprobado por un banco, ¿puedo ser cliente ION aun así?',
  answer: 'Sí, en ION buscamos la inclusión financiera en México por lo que no importa si no tienes historial crediticio o tu buró no está impecable, nuestras reglas son mucho más flexibles que las de un banco.',
  id: 'collider2'
},
{
  question: '¿Puedo sumar mis ingresos con otras personas para obtener un crédito mayor?',
  answer: 'Correcto y no necesita ser familiar, en ION nos caracteriza la flexibilidad.',
  id: 'collider3'
},
{
  question: 'Actualmente tengo deudas, ¿importa?',
  answer: 'No, siempre y cuando tengas capacidad de pago para hacer frente a un segundo crédito; pero, recuerda que con este crédito puedes liquidar tus deudas actuales y así tener todo consolidado en un mismo lugar.',
  id: 'collider4'
}]

const Questions = () => {
  const styles = useStyles(Styles)
  const color = Colors()
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <View variant='section' css={styles.container}>
      <View variant='article' css={styles.subContainer}>
        <Text variant={isMobile ? 'h5' : 'h4'} css={styles.title}>Preguntas frecuentes</Text>
        <Text variant='subtitle' css={styles.subtitle}>Esperamos poder ayudarte con esta información adicional</Text>
        {questions.map((item) =>
          <Collider
            title={item.question}
            content={item.answer}
            css={styles.collider}
            titleColor={color.broker}
            iconColor={color.broker}
            id={item.id}
            key={item.id}
          />
        )}
      </View>
    </View>
  )
}

export default Questions
